export default __webpack_public_path__ + "static/media/stock-photo-fresh-strawberries-removebg-preview.7345f281.png";